
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 11.5H1.72l3.2-3.14a.5.5 0 00-.7-.72l-4.07 4a.5.5 0 00-.1.16.5.5 0 000 .4.5.5 0 00.1.15l4.07 4a.5.5 0 00.7-.71l-3.2-3.14H10a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M23.5 24h-19a.5.5 0 01-.5-.5v-3.8a.5.5 0 011 0V23h18V1H5v3.3a.5.5 0 11-1 0V.5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v23a.5.5 0 01-.5.5z"}})])
          )
        }
      }
    